import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { B as BoxStyled } from './Box.styles-DM6VXnAC.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-1m8IJOfp.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const Box = ({
  children,
  flex,
  basis,
  grow,
  shrink,
  renderAs,
  padding = 'large',
  paddingBlockStart,
  paddingBlockEnd,
  paddingInlineStart,
  paddingInlineEnd,
  bgColor,
  square = false,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('box')
}, /*#__PURE__*/React__default.createElement(BoxStyled, _extends({}, rest, {
  $bgColor: bgColor,
  as: renderAs !== null && renderAs !== void 0 ? renderAs : 'div',
  $flex: flex,
  $basis: basis,
  $grow: grow,
  $shrink: shrink,
  $padding: padding,
  $paddingBlockStart: paddingBlockStart,
  $paddingBlockEnd: paddingBlockEnd,
  $paddingInlineStart: paddingInlineStart,
  $paddingInlineEnd: paddingInlineEnd,
  $square: square
}), children));

export { Box as B };
//# sourceMappingURL=Box-CUhfkbBK.js.map
